module.exports = __webpack_public_path__ + "img/covid-banner-desktop.41f3a95c.png";